import MaterialIcon from "common/MaterialIcon/MaterialIcon";
import sanitize from "utils/SanitizeHtml";
import Alert from "react-bootstrap/Alert";

const ErrorMessage = ({ wrapperClassName, errorClassName, error }) => {
  return (
    <div className={`${wrapperClassName} p-0`}>
      <Alert
        key="danger"
        variant="danger"
        show={true}
        className={`${errorClassName} error-message mb-0`}
      >
        {error &&
          (Array.isArray(error) ? (
            error?.map((e, index) => (
              <div className="d-flex" key={index}>
                <MaterialIcon iconName="error" wrapperClassName="mx-2" />
                <span
                  dangerouslySetInnerHTML={sanitize(
                    `${error.errorCode ? `${error.errorCode} - ` : ""}${
                      error.errorMessage
                    }`
                  )}
                />
              </div>
            ))
          ) : (
            <div className="d-flex align-items-center">
              <MaterialIcon iconName="error" wrapperClassName="me-2" />
              <span
                  dangerouslySetInnerHTML={sanitize(
                    `${error.errorCode ? `${error.errorCode} - ` : ""}${
                      error.errorMessage
                    }`
                  )}
              />
            </div>
          ))}
      </Alert>
    </div>
  );
};

export default ErrorMessage;
ErrorMessage.defaultProps = {
  errorClassName: "",
  wrapperClassName: "",
};
